module.exports = __webpack_public_path__ + "static/media/parkingAvailable.b7b3dc47.svg";